import { render, staticRenderFns } from "./conversation-image-editor.vue?vue&type=template&id=64e04842"
import script from "./conversation-image-editor.ts?vue&type=script&lang=ts&external"
export * from "./conversation-image-editor.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports